import { GetterTree } from 'vuex';
import { RolesState } from '@/store/modules/roles/types';
import { RootState } from '@/store/types';

export const getters: GetterTree<RolesState, RootState> = {
  appRoles: (state) => state.appRoles
};
